<template>
  <div class="addMessageType">
    <!--新增-->
    <el-dialog
      :title="$t('messageType.form.sendMessageTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        label-width="auto"
        :rules="rules"
        :model="addList"
        ref="addList"
        :label-position="'right'"
      >
        <el-form-item :label="$t('messageType.form.channel')" prop="type">
          <el-checkbox-group v-model="form.type">
            <el-checkbox v-for="item in channelList" :label="item.label" :key="item.value" />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.date')">
          <el-date-picker
            v-model="form.date"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('messageType.form.datePlaceholder')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.person')" prop="resource">
          <SearchModal
            ref="searchModal"
            :propName="person.propName"
            :propCode="person.propCode"
            className="customer-search"
            model="returnSalesmanNo"
            :placeholder="$t('messageType.form.personPlaceholder')"
            :API="person.API"
            :query="person.query"
            :page="person.page"
            :searchColumns="person.searchColumns"
            :columnList="person.columnList"
            :currentValue="form.returnSalesmanName"
            @setSearchModal="setSalesman"
          ></SearchModal>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd = false" :loading="load">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="addSure()" :loading="load">{{
          $t('dialog.save')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/messageCenter/messageTemp.js';
  import SearchModal from '@/components/SearchModal';
  import DataBaseAPI from '@/api/dataBase';
  export default {
    name: 'sendMessage',
    components: {
      SearchModal,
    },
    data() {
      // 校验特殊字符
      // var specialValidate = (rule, value, callback) => {
      //   var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
      //   if (value.match(reg)) {
      //     callback(new Error(this.$t('confirm.donNotEmoticons')));
      //   } else {
      //     callback();
      //   }
      // };
      return {
        load: false,
        dialogAdd: false,
        userList: [],
        receiverListStr: [],
        addList: {},
        channelList: [], //发送渠道
        form: {
          type: [],
          resource: [],
          date: '',
        },
        rules: {
          //  type: [
          //   { required: true, message: this.$t("messageType.form.typePlaceholder"), trigger: "blur" },
          // ],
          // resource: [
          //   { required: true, message: this.$t("messageType.form.personPlaceholder"), trigger: "blur" },
          // ]
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //人员
      person() {
        return {
          API: DataBaseAPI.PERSON_LIST_API,
          propCode: 'id',
          propName: 'personName', // 输入框展示内容
          query: {
            userCompany: null,
            dataStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: window.vm.$t('personnel.search.personnelInformation'),
              prop: 'personInfo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'personNo',
              label: window.vm.$t('personnel.addpersonnel.personNo'),
              width: 100,
            },
            {
              prop: 'personName',
              label: window.vm.$t('personnel.table.Name'),
              width: 100,
            },
            {
              prop: 'personCompanyName',
              label: window.vm.$t('personnel.table.company'),
              width: 150,
            },
            {
              prop: 'personDepartmentName',
              label: window.vm.$t('personnel.table.department'),
            },
            {
              prop: 'personMobilePhone',
              label: window.vm.$t('personnel.table.phone'),
              width: 100,
            },
            {
              prop: 'personEmail',
              label: window.vm.$t('personnel.table.email'),
              width: 120,
            },
            {
              prop: 'dataStatus',
              label: window.vm.$t('personnel.table.dataState'),
              width: 100,
            },
          ],
        };
      },
    },
    methods: {
      openDialog(flag, id) {
        if (this.$refs['addList']) {
          this.$refs['addList'].resetFields();
        }
        this.getData(id);
        this.getChannelType();
        this.dialogAdd = flag;
      },
      //获取
      getChannelType() {
        //消息状态
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'message_send_channel',
            tenantCode: this.userInfo.userInfo.tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.channelList = res.data.data;
            }
          });
      },
      //获取信息
      getData(id) {
        this.$axios.get(API.MESSAGE_TEMP_DETAIL_API + id).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.addList = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //选择人员
      setSalesman(name, val) {
        if (val.length > 0) {
          let receiverListStr = [];
          val.map((item) => {
            let obj = {
              personId: item.id,
              personNo: item.personNo,
              personName: item.personName,
              personMobilePhone: item.personMobilePhone,
              personEmail: item.personEmail,
            };
            receiverListStr.push(obj);
          });
          this.receiverListStr = receiverListStr;
        }
      },
      //保存
      addSure() {
        //console.log(this.form);return
        let typeList = [];
        this.form.type.map((item) => {
          this.channelList.map((channel) => {
            if (channel.label == item) {
              typeList.push(channel.value);
            }
          });
        });
        this.addList.channels = typeList.join(',');
        this.addList.sendTime = this.form.date;
        this.addList.messageTemplateId = this.addList.id;
        this.addList.receiverListStr = JSON.stringify(this.receiverListStr);
        //this.addList.receiverIds = this.ids.join(',')
        this.$refs.addList.validate((valid) => {
          if (valid) {
            this.load = true;
            this.$axios.post(API.MESSAGE_SEND_API, this.addList).then((res) => {
              this.load = false;
              if (0 != res.data.code) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              } else {
                this.dialogAdd = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
